export default __webpack_public_path__ + "static/media/3.c58c8e24.jpg";